import * as yup from 'yup';
import type { AnyObject } from 'yup';
import type { Maybe } from '@gov-nx/core/types';
import type { CommonMultiselectProps } from '@gov-nx/ui/types';

export type MultiselectDefinition = {
	schema: yup.ArraySchema<
		(string | undefined)[] | undefined,
		AnyObject,
		Maybe<string>
	>;
	defaultValue: string[];
	field: CommonMultiselectProps;
};

interface FieldProps {
	name: string;
	label: string;
	isDisabled?: boolean;
	isRequired?: boolean;
	isRequiredMessage?: string;
	options: { value: string; label: string; isDisabled?: boolean }[];
	placeholder: string;
	defaultValue?: string[];
	message?: string;
}

export const getMultiselectDefinition = (
	props: FieldProps
): MultiselectDefinition => {
	let schema = yup.array().of(yup.string());

	if (props.isRequired) {
		schema = schema
			.required(props.isRequiredMessage)
			.min(1, props.isRequiredMessage);
	}

	return {
		schema,
		defaultValue: props.defaultValue ?? [],
		field: {
			field: {
				name: props.name,
				isDisabled: props.isDisabled,
				options: props.options,
				placeholder: props.placeholder,
			},
			label: { children: props.label },
			messages: props.message
				? { messages: { children: props.message } }
				: undefined,
		},
	};
};
